/* eslint-disable no-restricted-properties */
/**
 *
 * #### Use it with null-coaelsing operator
 * For example:
 * ```
 *    getInsidedData().device
 *    getInsidedData().user.userid
 * ```
 *
 * #### Note:
 * The implementation of this API is subject to change.
 * It might be wise to use Provider + Context functionality.
 * Although, for now it's simple abstraction layer
 */
export const getInsidedData = <T extends keyof InsidedData>(key: T): InsidedData[T] => {
  if (typeof window === 'undefined') {
    throw new Error('inSidedData is accessible in browser environment only')
  }
  if ('inSidedData' in window) {
    return window.inSidedData[key]
  }

  throw new Error('inSidedData is not initialized')
}

export const setInsidedData = <T extends keyof InsidedData>(
  key: T,
  payload: InsidedData[T]
): void => {
  if (typeof window === 'undefined') {
    throw new Error('inSidedData is accessible in browser environment only')
  }

  if (typeof window.inSidedData !== 'object') {
    console.error(`inSidedData was not initialized. The "${key}" is not updated`)
    return
  }

  window.inSidedData[key] = payload
}
